
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hazardous-waste-disposal/[city]",
      function () {
        return require("private-next-pages/hazardous-waste-disposal/[city].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hazardous-waste-disposal/[city]"])
      });
    }
  